import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55010d56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = { class: "module-tabs mb-20" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-shopping-cart" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-chart-line-up" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SalesList = _resolveComponent("SalesList")!
  const _component_SalesReportsTab = _resolveComponent("SalesReportsTab")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["module-tab", { active: _ctx.activeTab === 'sales' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'sales'))
        }, [
          _hoisted_4,
          _createTextVNode(" Vendas ")
        ], 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["module-tab", { active: _ctx.activeTab === 'reports' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'reports'))
        }, [
          _hoisted_5,
          _createTextVNode(" Relatórios ")
        ], 2)
      ]),
      (_ctx.activeTab === 'sales')
        ? (_openBlock(), _createBlock(_component_SalesList, { key: 0 }))
        : (_openBlock(), _createBlock(_component_SalesReportsTab, { key: 1 }))
    ])
  ]))
}